import React from 'react'

import Hero from '@components/Content/Hero/Hero'
import Video from '@components/Content/Video/Video'

import { ButtonType } from '@contracts/Components/Button'
import { HeroType } from '@contracts/Components/Hero'

import * as styles from './HomepageHero.module.scss'

interface Props {
	data: HeroType
	background: React.ReactNode
	scrollTo: React.RefObject<HTMLDivElement>
	classes?: {
		titles?: string
		title?: string
	}
}

const HomepageHero = (props: Props) => {
	const video = (
		<Video
			m3u8_url="/videos/homepage-hero/hero.m3u8"
			mp4_url="/videos/homepage-hero/hero.mp4"
			eager={true}
			config={{
				width: '100%',
				height: '100%',
				loop: true,
				controls: false,
				muted: true,
				playing: true,
			}}
		/>
	)

	// Intercept the button and make it scroll to the appropriate section
	const button: ButtonType = {
		...props.data.button,
		scrollTo: props.scrollTo,
		buttonType: 'scrollTo',
	}

	const heroData = {
		...props.data,
		button,
	}

	return (
		<Hero
			data={heroData}
			background={props.background}
			video={video}
			style="full"
			className={styles.hero}
			classes={props.classes}
		/>
	)
}

HomepageHero.defaultProps = {
	classes: {},
}

export default HomepageHero
